/**
 * Keyboard key constants
 */
export const KEYBOARD_KEYS = {
  BACKSPACE: "Backspace",
  ESCAPE: "Escape",
  ENTER: "Enter",
};
